import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { updateProfile } from '../../api/auth.api';

const LangSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { isAuthenticated } = useAuthStore();

  const languages = [
    { code: 'ko', label: '한국어' },
    { code: 'en', label: 'EN' },
    { code: 'ja', label: '日本語' },
  ];

  const handleLanguageChange = async (langCode: string) => {
    i18n.changeLanguage(langCode);
    if (isAuthenticated) {
      try {
        await updateProfile({ preferences: { language: langCode } });
      } catch {
        // Silent fail — localStorage still has the value
      }
    }
  };

  return (
    <div className="inline-flex items-center bg-gray-100 rounded-full p-1 text-xs">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={`px-3 py-2 min-h-[36px] rounded-full transition-colors ${
            i18n.language === lang.code || i18n.language.startsWith(lang.code)
              ? 'bg-blue-600 text-white'
              : 'text-gray-700 hover:text-gray-900'
          }`}
          aria-label={`Switch to ${lang.label}`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LangSwitcher;
